import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { getDownloadURL, uploadBytes } from 'firebase/storage';
import { ref } from 'firebase/storage';
import { db, storage as firebaseStorage, storageRef } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
// import 'bootstrap/dist/css/bootstrap.min.css';

const ProfileModal = ({ show, handleClose, playerData, updatePlayerData }) => {
  const [name, setName] = useState(playerData.name);
  const [avatar, setAvatar] = useState(playerData.avatar);
  const [customAvatar, setCustomAvatar] = useState(null);

  const handleCustomAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCustomAvatar(file);

      const reader = new FileReader();
      reader.onload = () => {
        setAvatar('custom');
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const updatedPlayerData = { name };
  
    try {
      if (customAvatar) {
        const avatarRef = ref(storageRef, `avatarsImage/${uuidv4()}_${customAvatar.name}`);
        await uploadBytes(avatarRef, customAvatar);
        const avatarUrl = await getDownloadURL(avatarRef);
        updatedPlayerData.avatar = avatarUrl;
      }
  
      // Fetch the current player data
      const playerRef = doc(db, 'players', playerData.id);
      const playerSnap = await getDoc(playerRef);
  
      if (playerSnap.exists()) {
        const currentData = playerSnap.data();
        // Merge the existing data with the updated data
        const newPlayerData = { ...currentData, ...updatedPlayerData };
  
        await updateDoc(playerRef, newPlayerData);
        localStorage.setItem('playerData', JSON.stringify(newPlayerData));
        if (updatePlayerData) {
          updatePlayerData(newPlayerData);  // Add the check here
        }
        handleClose();
      } else {
        console.error('Player data does not exist');
      }
    } catch (error) {
      console.error('Error updating player data: ', error);
      alert('Error updating player data. Please try again.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>My Profile</Modal.Title>
        <button type="button" onClick={handleClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Avatar</Form.Label>
            <div className="d-flex justify-content-around">
              <div
                className={`avatar ${avatar === playerData.avatar ? 'selected' : ''}`}
              >
                <img src={avatar} alt="Current Avatar" />
              </div>
              <div>
              <div
                className={`avatar ${avatar === 'custom' ? 'selected' : ''}`}
                onClick={() => document.getElementById('customAvatarInput').click()}
              >
                {avatar === 'custom' && customAvatar && (
                  <img src={URL.createObjectURL(customAvatar)} alt="Custom Avatar" />
                )}
                {!customAvatar && <span className="custom-avatar-text"><img className='add-image-btn' src='/quiz-zone/image/add-image.png'/></span>}
              </div>
                 <span>add your image</span>
              </div>
            </div>
            <Form.Control
              type="file"
              id="customAvatarInput"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleCustomAvatarChange}
            />  
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit Changes
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
